export const SPORTS_ROUTES = '/forms/';

export const refreshSportsUser = () => {
  try {
    window.parent.postMessage({ type: 'refresh_user' }, '*');
    console.log('[SPORTS]: user refreshed');
  } catch (error) {
    console.error('refreshSportsUser failed', error);
  }
};

export const closeSportsModal = () => {
  try {
    window.parent.postMessage({ type: 'close' }, '*');
    console.log('[SPORTS]: modal closed');
  } catch (error) {
    console.error('closeSportsModal failed', error);
  }
};
